export default {
  meterPlace: {
    step1: "Étape 1",
    step2: "Étape 2",
    step3: "Étape 3",
    step4: "Étape 4",
    addTitle: "Ajouter un compteur",
    residenceZone: "Zone de résidence",
    villageQuarter: "Village / Quartier",
    chooseVillage: "Choisir un village",
    gpsPosition: "Position GPS",
    latitude: "Latitude",
    longitude: "Longitude",
    meterNumber: "Numéro du compteur",
    twoWireMeters: "Compteurs 2 fils",
    fourWireMeters: "Compteurs 4 fils",
    electricityAvailable: "Électricité disponible",
    heavyEquipmentAvailable: "Équipement lourd disponible",
    subscriberType: "Type d'abonné",
    chooseSubscriberType: "Choisir le type d'abonné",
    companyName: "Nom de l'entreprise",
    surveyorName: "Nom du technicien",
    deleteTitle: "Supprimer l'emplacement compteur",
  },
  place: {
    breakerTypeWished: "Type de disjoncteur souhaité",
    add: "Ajouter",
    number: "Place Compteur N°{num}",
    villageNeighborhood: "Village / Quartier",
    surveyor: "Enquêteur",
    surveyDate: "Date enquête",
    subscriberType: "Type abonné",
    businessName: "Raison sociale",
    detail1: "Détail 1",
    detail2: "Détail 2",
    other: "Autre",
    companyWorks: "Entreprise travaux",
    workZone: "Zone travaux",
    agency: "Agence SBEE",
    eligible: "Éligible",
    solded: "Soldée",
    latitude: "Latitude",
    longitude: "Longitude",
    nbMeters2filsWished: "Nb compteurs 2 fils souhaité",
    nbMeters4filsWished: "Nb compteurs 4 fils souhaité",
    circuitBreakerType: "Type disjoncteur souhaité",
    availableElectricSystem: "Système électrique disponible",
    heavyEquip: "Équipement lourd prévu",
    comment: "Commentaire",
    changeEligibility: "Changer L'éligibilité",
    metersList: "Liste des compteurs",
    viewMap: "Voir sur la carte",
    none: "Aucun emplacement compteur",
    editTitle: "Modifier un emplacement compteur",
    nb2wires: "Nombre de compteurs 2 fils",
    nb4wires: "Nombre de compteurs 4 fils",
    selectCompany: "Sélectionner une entreprise",
    company: "Entreprise",
    selectBreakerType: "Sélectionner un type de disjoncteur"
  },
};
